import DraggableIcon from './DraggableIcon';

export default DraggableIcon;
